import dayjs from 'dayjs';
import { FC } from 'react';
import EditIcon from '@/assets/edit.svg';
import { InfoTable } from '@/components/info-table';
import { Button } from '@/components/ui/button';
import { strings } from '@/constants/strings';
import { DrawerContentLayout } from '@/layouts/drawer-content-layout';
import { ApplicationUser } from '@/types/application-user';

export type ViewUserProps = {
  canEdit: boolean;
  user: Pick<
    ApplicationUser,
    'firstName' | 'lastName' | 'email' | 'role' | 'organisation' | 'lastLogin'
  >;
  onClose: () => void;
  onEdit: () => void;
};

export const ViewUser: FC<ViewUserProps> = ({
  canEdit,
  user,
  onClose,
  onEdit,
}) => (
  <DrawerContentLayout
    buttonItems={[
      canEdit ? (
        <Button key="edit" onClick={onEdit} variant="primary">
          <EditIcon />
          {strings.users.drawer_view.edit}
        </Button>
      ) : (
        <Button key="close" onClick={onClose} variant="secondary">
          {strings.users.drawer_view.close}
        </Button>
      ),
    ]}
    mainContent={
      <InfoTable
        rows={[
          { label: 'First name', value: user.firstName },
          { label: 'Last name', value: user.lastName },
          { label: 'Email', value: user.email },
          { label: 'Role', value: user.role.roleName },
          {
            label: 'Organisation',
            value: user.organisation?.name ?? 'Unassigned',
            valueClassName: user.organisation?.name
              ? undefined
              : 'text-warning',
          },
          {
            label: 'Last Login',
            value: user.lastLogin
              ? dayjs(user.lastLogin).format('DD/MM/YYYY HH:mm')
              : '-',
          },
        ]}
        title="User Information"
      />
    }
  />
);
